import { AskConsumerLayout } from "@ui/layouts/AskConsumerLayout/AskConsumerLayout";
import { render } from "solid-js/web";
import { BoardDetailsApp } from "~/modules/askgvt/boards/details/BoardDetailsApp";

declare const pageVars: {
	boardId: string;
	ownerHandle: string;
	viewerIsOwner: boolean;
	isInfluencer: boolean;
};

document.addEventListener("DOMContentLoaded", () => {
	render(
		() => (
			<AskConsumerLayout showHeader={false} signedOutTopNav>
				<BoardDetailsApp
					boardId={pageVars.boardId}
					readOnly
					backLink={`/@${pageVars.ownerHandle}`}
					viewerIsOwner={pageVars.viewerIsOwner}
				/>
			</AskConsumerLayout>
		),
		document.body,
	);
});
